import { callFunction } from "../cao";

export const setBoxcatMint = async (proxyAddr, amount, index, price) => {
    return await callFunction(proxyAddr, "mint", [amount, index], price, true);
};